import { Badge } from "@/components/ui/badge"
import type { CredentialItem } from "@/lib/credential"
import {
  Globe,
  ShieldCheck,
  Eye,
  Crown,
} from "lucide-react"
import {
  "components.credentials.permissions.tenant_admin" as components_credentials_permissions_tenant_admin,
  "components.credentials.permissions.read_only" as components_credentials_permissions_read_only
} from "@/paraglide/messages.js"

type Props = {
  level: CredentialItem["accessLevel"]
}

export function AccessLevelBadge({ level }: Props) {
  switch (level) {
    case "global":
      return (
        <Badge
          variant="secondary"
          className="gap-1 text-blue-600 bg-blue-50 border border-blue-200"
        >
          <Globe className="h-3 w-3" />
          Global
        </Badge>
      )

    case "admin":
      return (
        <Badge
          variant="secondary"
          className="gap-1 text-green-600 bg-green-50 border border-green-200"
        >
          <ShieldCheck className="h-3 w-3" />
          Admin
        </Badge>
      )

    case "read":
      return (
        <Badge
          variant="secondary"
          className="gap-1 text-muted-foreground bg-muted border"
        >
          <Eye className="h-3 w-3" />
          {components_credentials_permissions_read_only()}
        </Badge>
      )

    case "tenant-admin":
      return (
        <Badge
          variant="secondary"
          className="gap-1 text-amber-600 bg-amber-50 border border-amber-200"
        >
          <Crown className="h-3 w-3" />
          {components_credentials_permissions_tenant_admin()}
        </Badge>
      )

    default:
      return null
  }
}
